import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import React, { Component } from "react";
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { mainListItems, secondaryListItems } from '../components/listItems';

import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SettingsIcon from '@material-ui/icons/Settings'
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { authenticationService } from '_services';
import clsx from 'clsx';
import { history } from '_helpers';
import routes from "../_routes/routes.js";
import { withStyles } from '@material-ui/core/styles';

const switchRoutes = (
    <Switch>
      {routes.map((prop, key) => {
        if (prop.layout === "/admin") {
          return (
            <Route
              path={prop.layout + prop.path}
              component={prop.component}
              key={key}
            />
          );
        }
        return null;
      })}
      <Redirect from="/" to="/admin/login" />
      <Redirect from="/admin" to="/admin/login" />
    </Switch>
  );

  const themeX = createMuiTheme({
    palette: {
      type: "light",
      grey: {
        800: "#000000", // overrides failed
        900: "#121212" // overrides success
      },
      primary: {
        main: '#2f1d75'
      }
    }
  });

  const drawerWidth = 240;

  const useStyles = theme => ({
    root: {
      display: 'flex',
    },
    toolbar: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: 'none',
    },
    title: {
      flexGrow: 1,
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 240,
    },
  });
  

class Admin extends Component {
  constructor(props){
    super()
    this.state = {
      open: false,
      currentUser: true,
      currentUserId: ''
    }
  }

  handleDrawerOpen = () => {
      this.setState({
        open: true
      })
  };
  handleDrawerClose = () => {
    this.setState({
      open: false
    })
  };
  getLogoutTip() {
    return 
  }

  componentDidMount() {
    authenticationService.currentUser.subscribe(x => this.setState({ 
      currentUser: x,
     }));
     authenticationService.currentUserId.subscribe(x => this.setState({ 
      currentUserId: x
     }));
  }

  logout() {
      authenticationService.logout();
      history.push('/login');
  }

  render() {
    // const classes = useStyles();
    const { classes } = this.props;

    // const getRoute = () => {
    //     return window.location.pathname !== "/admin/test";
    // };
    // const [open, setOpen] = React.useState(false);
    // const handleDrawerOpen = () => {
    //     setOpen(true);
    // };
    // const handleDrawerClose = () => {
    //     setOpen(false);
    // };
    // const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    return(
      <MuiThemeProvider theme={themeX}>
        <Router history={history}>
          <div className={classes.root}>
          <CssBaseline />
          <AppBar
              position="fixed"
              className={clsx(classes.appBar, this.state.open && classes.appBarShift)}
          >
              <Toolbar className={classes.toolbar}>
              <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={this.handleDrawerOpen}
                  className={clsx(
                  classes.menuButton,
                  this.state.open && classes.menuButtonHidden,
                  )}
              >
                  <MenuIcon />
              </IconButton>
              <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  className={classes.title}
              >
                {/* <Logo className={classes.logo} style={{ height: "inherit" , width: 98, paddingRight: 8}}/> */}
                  EPT Portal
              </Typography>
              <IconButton color="inherit">
                  <Badge badgeContent={4} color="secondary">
                  <NotificationsIcon />
                  </Badge>
              </IconButton>

              <IconButton color="inherit">
                  <Badge color="secondary">
                  <SettingsIcon />
                  </Badge>
              </IconButton>
              
              {this.state.currentUser &&
                <Tooltip title={"Logout " + this.state.currentUserId}>
                  <IconButton id="logout"  color="inherit">
                      <Badge color="secondary">
                      <ExitToAppIcon  onClick={this.logout} />
                      </Badge>
                  </IconButton>
                </Tooltip>
              }
              </Toolbar>
          </AppBar>
          <Drawer
              variant="permanent"
              classes={{
              paper: clsx(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
              }}
              open={this.state.open}
          >
              <div className={classes.toolbarIcon}>
              <IconButton onClick={this.handleDrawerClose}>
                  <ChevronLeftIcon />
              </IconButton>
              </div>
              <Divider />
              <List>{mainListItems}</List>
              <Divider />
              <List>{secondaryListItems}</List>
          </Drawer>
          <main className={classes.content}>
              <div className={classes.appBarSpacer} />
              {/* {getRoute() ? (
              <div className={classes.content}>
                  <div className={classes.container}>{switchRoutes}</div>
              </div>
              ) : ( */}
              <div className={classes.container}>{switchRoutes}</div>
              {/* )} */}
          </main>
          </div>
        </Router>
      </MuiThemeProvider>

    )
  }
}

// export default Admin
export default withStyles(useStyles)(Admin)
